var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3822",
    "data-name": "Groupe 3822",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.313,
    height: 34.141,
    viewBox: "0 0 27.313 34.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1728",
    "data-name": "Rectangle 1728",
    width: 27.313,
    height: 34.141,
    fill: "#6639b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3816",
    "data-name": "Groupe 3816",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13598",
    "data-name": "Trac\\xE9 13598",
    d: "M4.484,14.2H3.023a.069.069,0,0,0-.078.078v2.231a.069.069,0,0,0,.078.078H4.484a1.2,1.2,0,1,0,0-2.387",
    transform: "translate(1.311 6.319)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13599",
    "data-name": "Trac\\xE9 13599",
    d: "M9.553,14.233H8.667a.069.069,0,0,0-.079.078v5.3a.069.069,0,0,0,.079.078h.886c.887,0,1.526-.3,1.749-1a6.463,6.463,0,0,0,.156-1.721,6.469,6.469,0,0,0-.156-1.723c-.223-.7-.861-1-1.749-1",
    transform: "translate(3.823 6.335)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13600",
    "data-name": "Trac\\xE9 13600",
    d: "M26.458,13.658H22.191a8.534,8.534,0,0,1-8.535-8.535V.856A.852.852,0,0,0,12.8,0H6.828A6.828,6.828,0,0,0,0,6.828H0V27.312a6.829,6.829,0,0,0,6.828,6.828H20.484a6.828,6.828,0,0,0,6.828-6.828v-12.8a.853.853,0,0,0-.854-.854M5.913,24.56H4.335a.071.071,0,0,0-.079.079v2.152A.943.943,0,0,1,3.3,27.808a.945.945,0,0,1-.964-1.017V19.707a.783.783,0,0,1,.834-.847h2.74a2.859,2.859,0,1,1,0,5.7m11.049,1.123c-.47,1.448-1.645,2.048-3.535,2.048h-2.1a.775.775,0,0,1-.835-.835V19.707a.785.785,0,0,1,.835-.847h2.1c1.89,0,3.065.6,3.535,2.048a7.322,7.322,0,0,1,.262,2.387,7.328,7.328,0,0,1-.262,2.387m7.123-5.166H20.942a.068.068,0,0,0-.078.078V22.46a.068.068,0,0,0,.078.078h2.5a.825.825,0,1,1,0,1.645h-2.5a.068.068,0,0,0-.078.078v2.53a.961.961,0,1,1-1.918,0V19.707a.785.785,0,0,1,.835-.847h4.3a.83.83,0,1,1,0,1.656",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13601",
    "data-name": "Trac\\xE9 13601",
    d: "M16.938,10.073l3.783,0a.723.723,0,0,0,.7-1.046,5.1,5.1,0,0,0-.867-1.156L14.019,1.33A5.1,5.1,0,0,0,12.863.463a.722.722,0,0,0-.971.319.73.73,0,0,0-.075.383V4.952a5.122,5.122,0,0,0,5.121,5.121",
    transform: "translate(5.259 0.171)",
    fill: "#6639b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.67f781bbc1d4245416d8dc136455e3c0.svg";
export { ForwardRef as ReactComponent };